import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import React from "react";
import { Amplify } from "aws-amplify";
import { CookieStorage } from "aws-amplify/utils";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { identityPoolId, isProduction, userPoolId, userPoolWebClientId } from "../config";
import RecordLoginOnAuth from "./RecordLoginOnAuth";

cognitoUserPoolsTokenProvider.setKeyValueStorage(
  new CookieStorage({
    domain: isProduction ? ".hssoft.com" : window.location.hostname,
    secure: isProduction,
  })
);

Amplify.configure({
  Auth: {
    Cognito: {
      identityPoolId: identityPoolId as string,
      userPoolId: userPoolId as string,
      userPoolClientId: userPoolWebClientId as string,
      loginWith: {
        email: true,
      },
    },
  },
});

const AuthWrapper: React.FC = ({ children }) => (
  <Authenticator
    hideSignUp
    loginMechanisms={["email"]}
    formFields={{
      signIn: {
        username: {
          type: "email",
          label: "Email",
          placeholder: "Email",
          isRequired: true,
        },
        password: {
          label: "Password",
          placeholder: "Password",
          isRequired: true,
        },
      },
    }}
  >
    {({ user }) =>
      user ? (
        <>
          <RecordLoginOnAuth user={user} />
          {children}
        </>
      ) : (
        <></>
      )
    }
  </Authenticator>
);

export default AuthWrapper;
